/**
 * Official Tyris Isotipo SVG and DISCIPLINE GYM + by Tyris Co-Branding Component
 * Source of Truth: TYRIS_DESIGN_SYSTEM.md & Manual de Identidad Tyris 2026.
 */

export function getTyrisIsotipoSvg(size = 28, className = 'tyris-logo-icon'): string {
  return `
    <svg class="${className}" width="${size}" height="${size}" viewBox="0 0 54.11 64.84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tyris-isotipo">
        <path fill="currentColor" d="m22.7,58.9c1.12-1.03,1.02-2.48,1.02-4.01V20.68c0-.14.01-.27.03-.41l1.45-12.81-8.49,2.51L27.33,0l10.31,10-7.93-2.54,1.45,12.81c.02.14.02.27.02.41v34.23c0,1.52-.16,2.95.96,3.97l5.54,5.96h-20.74l5.76-5.94Z"/>
        <path fill="currentColor" d="m21.91,14.63c.25,0,.38.3.21.48l-.9.94-4.2,4.35c-.05.06-.13.09-.21.09H7.81c-.18,0,.03,11.57-.07,11.36C7.74,31.85-.9,14.61.08,14.62h16.86s2.41,0,2.41,0h2.57Z"/>
        <path fill="currentColor" d="m32.2,14.63c-.25,0-.38.3-.21.48l.9.94,4.2,4.35c.05.06.13.09.21.09h9c.18,0-.03,11.57.07,11.36,0,0,8.65-17.23,7.67-17.23h-16.86s-2.41,0-2.41,0h-2.57Z"/>
        <polygon fill="currentColor" points="16.94 14.62 19.34 14.62 16.94 14.62 16.94 14.62"/>
      </g>
    </svg>
  `;
}

// Backward compatibility helper
export function getTyrisLogoSvg(size = 28, className = 'tyris-logo-icon'): string {
  return getTyrisIsotipoSvg(size, className);
}

export function getDisciplineGymBrandHeader(options: {
  size?: number;
  showSubtitle?: boolean;
  className?: string;
  isCompact?: boolean;
} = {}): string {
  const size = options.size || 22;
  const showSubtitle = options.showSubtitle ?? true;
  const className = options.className || 'discipline-brand-wrapper';
  const isCompact = options.isCompact ?? false;

  if (isCompact) {
    return `
      <div class="${className} compact">
        <div class="discipline-brand-title">DISCIPLINE GYM</div>
        <div class="tyris-powered-tag compact">
          <span class="tyris-by-text">by</span>
          ${getTyrisIsotipoSvg(size, 'tyris-tag-isotipo')}
          <span class="tyris-tag-name">TYRIS</span>
        </div>
      </div>
    `;
  }

  return `
    <div class="${className}">
      <h1 class="discipline-brand-title">DISCIPLINE GYM</h1>
      <div class="tyris-powered-tag">
        <span class="tyris-by-text">by</span>
        ${getTyrisIsotipoSvg(size, 'tyris-tag-isotipo')}
        <span class="tyris-tag-name">TYRIS</span>
      </div>
      ${showSubtitle ? `<p class="discipline-brand-subtitle">Tu gimnasio, siempre en movimiento</p>` : ''}
    </div>
  `;
}

// Alias for existing callers
export function getTyrisBrandHeader(options: { size?: number; showTagline?: boolean; className?: string } = {}): string {
  return getDisciplineGymBrandHeader({
    size: options.size,
    showSubtitle: options.showTagline,
    className: options.className
  });
}
